import { render } from "./FormDescarga.vue?vue&type=template&id=07e760d2&scoped=true"
import script from "./FormDescarga.vue?vue&type=script&lang=js"
export * from "./FormDescarga.vue?vue&type=script&lang=js"

import "./FormDescarga.vue?vue&type=style&index=0&id=07e760d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-07e760d2"

export default script